import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { round } from 'lodash';

@Directive({
    selector: '[appRoundInputValue]',
    standalone: false,
})
export class RoundInputValueDirective {
    @Input() set appRoundInputValue(positions: number) {
        this.positions = positions;
    }
    @Output() focusOut = new EventEmitter<number>();

    private positions: number;

    constructor(private element: ElementRef<HTMLInputElement>) {}

    @HostListener('focusout', ['$event'])
    onFocusOut() {
        const value: string = this.element.nativeElement.value;
        const current = Number(value);
        const next = round(current, this.positions);
        this.element.nativeElement.value = next.toString();
        this.focusOut.emit(next);
    }
}
